import { signInWithPopup } from "firebase/auth";
import { auth, provider, db } from "./firebase";
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Container, Button, Card, Row, Col } from "react-bootstrap";

function Home() {
  const navigate = useNavigate();

  const signInWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        await updateDoc(userRef, {
          lastOnline: serverTimestamp(),
        });
      } else {
        await setDoc(userRef, {
          userId: user.uid,
          name: user.displayName || "",
          email: user.email || "",
          profileImage: user.photoURL || "",
          createdAt: serverTimestamp(),
          lastOnline: serverTimestamp(),
          friends: [],
          blockedUsers: [],
        });
      }

      navigate("/profile");
    } catch (error) {
      console.error("ログインエラー:", error);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100" style={{ background: 'linear-gradient(135deg, #3b82f6, #9333ea)' }}>
      <Container className="text-center">
        <Row>
          <Col>
            <Card className="p-4 shadow-lg rounded-4" style={{ maxWidth: '400px', margin: '0 auto' }}>
              <Card.Body>
                <h2 className="mb-4" style={{ fontWeight: 'bold' }}>Welcome to <span style={{ color: '#3b82f6' }}>ChatApp</span></h2>
                <Button
                  variant="outline-primary"
                  size="lg"
                  className="w-100 py-3 border-2"
                  style={{ fontWeight: 'bold', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', transition: 'all 0.3s ease' }}
                  onClick={signInWithGoogle}
                >
                  Googleでログイン
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
